import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../../../shared/components/';
import { AddToBasket, RunningTotal, PublishAddToCartEvent } from '../../../../shared/services';

export default class AddToBasketButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isProcessing: false,
    };
  }

  addToBasket(stockNumber, quantity) {
    if (quantity % this.props.packSize !== 0 || quantity === 0) {
      if (this.props.onPackSizeError !== undefined) { this.props.onPackSizeError(); }
      return;
    }

    this.setState({
      isProcessing: true,
    });
    AddToBasket(stockNumber, quantity).then(() => {
      this.setState({
        isProcessing: false,
      });
      RunningTotal(); // returns a promise but we don't need to do anything once it resolves
      PublishAddToCartEvent(stockNumber, quantity, 'Product_New');
      if (this.props.onAddedToBasket !== undefined) { this.props.onAddedToBasket(); }
    }, () => {
      // At the moment the error will be swallowed but a error handling strategy is being considered
      this.setState({
        isProcessing: false,
      });
    });
  }

  render() {
    return (
      <div>
        {!this.state.isProcessing ?
          <Button
            customClass={'btn-add-to-basket'}
            primary
            large={this.props.isLarge}
            onClick={() => this.addToBasket(this.props.stockNumber, this.props.quantity)}
            label={this.props.label}
            disabled={this.props.disabled}
          /> :
          <span className={'icon icon-rs_39-loading ajax-loader add-to-basket-loader'} /> }
      </div>
    );
  }
}
AddToBasketButton.propTypes = {
  stockNumber: PropTypes.string,
  quantity: PropTypes.number,
  label: PropTypes.string,
  onAddedToBasket: PropTypes.func,
  isLarge: PropTypes.bool,
  packSize: PropTypes.number,
  onPackSizeError: PropTypes.func,
  disabled: PropTypes.bool,
};

AddToBasketButton.defaultProps = {
  stockNumber: '111-111',
  quantity: 1,
  label: 'click me',
  onAddedToBasket: undefined,
  isLarge: true,
  packSize: 1,
  onPackSizeError: undefined,
  disabled: false,
};



// WEBPACK FOOTER //
// ./src/main/ui/react/product/src/components/AddToBasketButton/AddToBasketButton.js